import React from 'react';
import PropTypes from 'prop-types';
import { INSTITUTIONS } from '@/shared/constants/institutions';
import { INSTITUTION_LOGOS } from '@/shared/constants/institutionLogos';
import './InstitutionLogo.css';

/**
 * An institution's logo, inline with the text around it.
 *
 * `surface` names what the logo sits on, not how it looks: a navy surface
 * needs the reversed mark, and using the standard one there renders navy text
 * on navy. The alt text is the full name, which is what a screen reader
 * announces. Pass `decorative` where the name is already printed beside the
 * logo: the alt text is then empty, so the name is not announced twice.
 */
function InstitutionLogo({
    institution,
    surface = 'light',
    decorative = false,
    className = '',
}) {
    const info = INSTITUTIONS[institution];
    if (!info) {
        return null;
    }
    return (
        <img
            src={INSTITUTION_LOGOS[surface][info.key]}
            alt={decorative ? '' : info.name}
            title={decorative ? undefined : info.name}
            className={`afe-inst-logo afe-inst-logo-${info.key} afe-inst-logo-on-${surface} ${className}`.trim()}
        />
    );
}

InstitutionLogo.propTypes = {
    institution: PropTypes.string,
    surface: PropTypes.oneOf(['light', 'dark']),
    decorative: PropTypes.bool,
    className: PropTypes.string,
};

export default InstitutionLogo;
